import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService, ReorderService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReferralRoutingModule } from './referral-routing.module';
import { ReferralComponent } from './referral.component';
import { MyDatePickerModule } from 'mydatepicker';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { dropdownModule } from 'src/app/dropdown/dropdown.module';
import { GoogleMapModule } from '../google-map/google-map.module';
import { ReferralNotesModule } from './referral-notes/referral-notes.module';
import { CaseManagerModule } from '../case-manager/case-manager.module';
import { CareCoordinatorModule } from '../care-coordinator/care-coordinator.module';
import { ClientEmployeeContactModule } from '../client-employee-contact/client-employee-contact.module';
@NgModule({
    declarations: [
        ReferralComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GridModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,
        ReferralRoutingModule,
        MyDatePickerModule,
        PDFExportModule,
        dropdownModule,
        GoogleMapModule,
        ReferralNotesModule,
        CaseManagerModule,
        CareCoordinatorModule,
        ClientEmployeeContactModule
    ],
    providers: [ColumnChooserService, PageService, SortService, FilterService, ResizeService,ReorderService
],
})
export class ReferralModule { }
